import { t } from "../../../../i18n";
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { IconHome, IconUsers, IconStethoscope, IconBuilding, IconUserHeart, IconCalendar } from '@tabler/icons-react';
import { portalConfig } from '../../../../configs/portal';
import { useAuth } from '../../../../auth/AuthProvider';
export default function MenuList({
  onNavigate
}) {
  const {
    pathname
  } = useLocation();
  const { role } = useAuth();
  return <List disablePadding sx={{
    pt: 1
  }}>
            {portalConfig.routes.filter(route => route.sidebar && (!route.allowedRoles || route.allowedRoles.includes(role?.name))).map(route => <ListItemButton key={route.id} component={Link} to={route.path} selected={pathname === route.path} aria-current={pathname === route.path ? 'page' : undefined} onClick={onNavigate} sx={{
      borderRadius: 0,
      py: 1.25,
      px: 2,
      color: '#fff',
      '& .MuiListItemIcon-root, &:hover .MuiListItemIcon-root, &.Mui-selected .MuiListItemIcon-root, &.Mui-selected:hover .MuiListItemIcon-root': {
        color: '#fff',
        '& svg': { color: 'inherit' }
      },
      '&:hover, &.Mui-selected, &.Mui-selected:hover': {
        bgcolor: 'rgba(255, 255, 255, 0.12)',
        color: '#fff'
      }
    }}>
                    <ListItemIcon sx={{
        minWidth: 36
      }}>
                        {route.id === 'administratives' ? <IconUsers stroke={1.5} size="1.3rem" /> : route.id === 'professionals' ? <IconStethoscope stroke={1.5} size="1.3rem" /> : route.id === 'organization' ? <IconBuilding stroke={1.5} size="1.3rem" /> : route.id === 'patients' ? <IconUserHeart stroke={1.5} size="1.3rem" /> : route.id === 'agenda' ? <IconCalendar stroke={1.5} size="1.3rem" /> : <IconHome stroke={1.5} size="1.3rem" />}
                    </ListItemIcon>
                    <ListItemText primary={<Typography variant={pathname === route.path ? 'h5' : 'body1'} color="inherit">
                            {t(route.title)}
                        </Typography>} />
                </ListItemButton>)}
        </List>;
}
MenuList.propTypes = {
  onNavigate: PropTypes.func.isRequired
};
